import { Grid, Item } from '@mui/material';
import React from 'react';
import './Contact.css'

const Contact = () => {
    return (
        <div className="contact">
            <h2>Contact With Us</h2>
            <a href="https://www.facebook.com/umdmohin">Facebook</a>
            <br />
            <a href="https://www.facebook.com/umdmohin">Linkdin</a>
            <br />
            <a href="https://www.facebook.com/umdmohin">Twitter</a>
        </div>
    );
};

export default Contact;